import http from '@/http-common';

class LoginService {
  async getFuncionarioForMenu(filial) {
    return http.get(`/funcionario/publicToken/${filial || 0}`);
  }

  async deletePublicToken(publicToken) {
    return http.delete(`/funcionario/publicToken/${publicToken}`);
  }

  async list(inputModel) {
    return http.post('/funcionario/search', inputModel);
  }

  async get(ide) {
    return http.get(`/funcionario/${ide}`);
  }

  async save(inputModel) {
    return http.post('/funcionario/', inputModel);
  }

  async getNextCodigo() {
    return http.get('/funcionario/nextCodigo');
  }

  async registrarPrivateToken(inputModel) {
    return http.post('/funcionario/registrarPrivateToken', inputModel);
  }

  async twoFactorAuth(input) {
    return http.post('/funcionario/responsavelTecnico/twoFactorAuth', input);
  }
}

export default new LoginService();
